import styled from "styled-components";

export const HeaderStyled = styled.header`
	padding: 10px 5%;
	margin-bottom: 7rem;
	color: var(--color-white-fixed);
	background-color: var(--color-brand-0);
	position: sticky;
	top: 0;

	z-index: 99;

	.container {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.logo {
			width: 150px;
			align-self: center;

			img {
				width: 100%;
			}
		}

		.navbar {
			font-weight: 600;

			display: flex;
			justify-content: space-between;
			align-items: center;
			column-gap: 3rem;

			.btn {
				padding: 0;
				border: solid 2px var(--color-white-fixed);
				border-radius: 5px;
			}

			@media (max-width: 860px) {
				display: none;
			}
		}
		.perfil-container {
			display: flex;
			column-gap: 1rem;

			.perfil-exemple {
				width: 40px;
				height: 40px;

				img {
					width: 100%;
					height: 100%;
					border-radius: 50%;
					background-color: var(--color-white-fixed);
				}
			}
		}

		#burger {
			cursor: pointer;

			@media (min-width: 860px) {
				display: none;
			}
		}

		.hamburguer-nav {
			position: absolute;
			top: 80px;
			right: 10px;
			background-color: red;
			z-index: 99;

			.hamburguer-navbar {
				padding: 2rem;
				display: flex;
				flex-direction: column;
				align-items: start;
				row-gap: 1rem;

				background-color: var(--color-brand-1);
				box-shadow: 1px 2px 3px var(--color-gray-1);
			}
		}
	}
`;
